import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index'
import store from './store'
import '@/assets/css/reset.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale';
import { i18n } from './i18n'
locale.i18n((key, value) => i18n.t(key, value)); // 兼容 Element UI 的语言包
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });

import Clipboard from 'v-clipboard'
Vue.use(Clipboard)

import VueLoadmore from 'vuejs-loadmore';
Vue.use(VueLoadmore);

import Web3 from 'web3'
Vue.prototype.$Web3 = Web3

import {timestampFormat,floatObj,getUnit,isContractAddress,abiDecoder,getAmountAccuracy,handleInputData,isDtt,convertToDecimal,FilterAddress,getDetailsAbiDecoder,isMobileByUA} from '@/utils/index'
import Decimal from "decimal.js";

Vue.prototype.$timestampFormat = timestampFormat;
Vue.prototype.$floatObj = floatObj;
Vue.prototype.$getUnit = getUnit
Vue.prototype.$isContractAddress = isContractAddress
Vue.prototype.$Decimal = Decimal
Vue.prototype.$abiDecoder = abiDecoder
Vue.prototype.$getAmountAccuracy = getAmountAccuracy
Vue.prototype.$handleInputData = handleInputData
Vue.prototype.$isDtt = isDtt
Vue.prototype.$convertToDecimal = convertToDecimal
Vue.prototype.$FilterAddress = FilterAddress
Vue.prototype.$getDetailsAbiDecoder = getDetailsAbiDecoder
Vue.prototype.$isMobile = isMobileByUA()
Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
